import React from 'react'

export default function Navbar() {
  return (
    <div className='p-3'>Navbar</div>
  )
}
